module.exports = __webpack_public_path__ + "img/community-divider.2242b682.svg";